import { render, staticRenderFns } from "./GiftCardType.vue?vue&type=template&id=178f7930&scoped=true"
import script from "./GiftCardType.vue?vue&type=script&lang=js"
export * from "./GiftCardType.vue?vue&type=script&lang=js"
import style0 from "./GiftCardType.vue?vue&type=style&index=0&id=178f7930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f7930",
  null
  
)

export default component.exports